import { cfgCdnBanners } from '@infinitro/config';
const CDN_BANNER_BASE = cfgCdnBanners();
export function buildBannerPath(id, mobile, variant, loc) {
    const v = variant === 'default' ? '' : `_${variant}`;
    const suffix = mobile ? `${v}-mobile` : v;
    const base = `${CDN_BANNER_BASE}${id}/`;
    const local = loc ? `${base}${loc}/` : base;
    return {
        primary: `${local}${id}${suffix}.png`,
        fallback: `${base}${id}${suffix}.png`
    };
}
export function buildBannerPathNew(promo, mobile, variant, loc) {
    const v = variant === 'default' ? '' : `_${variant}`;
    const base = `${CDN_BANNER_BASE}${promo.id}/`;
    const local = loc ? `${base}${loc}/` : base;
    const size = mobile ? promo.mobileBannerSize : promo.desktopBannerSize;
    const sizeBig = mobile ? promo.mobileBannerBigSize : promo.desktopBannerBigSize;
    const ext = 'png';
    return {
        primary: `${local}${promo.id}_${size}.${ext}`,
        primaryBig: `${local}${promo.id}_${sizeBig}.${ext}`,
        fallback: `${base}${promo.id}_${size}.${ext}`
    };
}
export function isFutureDate(date) {
    const today = new Date();
    return (date.getUTCFullYear() > today.getUTCFullYear() ||
        (date.getUTCFullYear() === today.getUTCFullYear() &&
            date.getUTCMonth() > today.getUTCMonth()) ||
        (date.getUTCFullYear() === today.getUTCFullYear() &&
            date.getUTCMonth() === today.getUTCMonth() &&
            date.getUTCDate() > today.getUTCDate()));
}
export function isFuture(date) {
    const now = new Date();
    return date.getTime() > now.getTime();
}
/**
 * Formats a date string/Date into a localized calendar date (DD/MM/YYYY style depends on locale),
 * always using the user's browser time zone by default.
 *
 * Behavior:
 * - If input is a string without timezone (e.g., "2025-09-25T00:00:00"), it is treated as UTC (adds 'Z').
 * - If input is a Date and assumeNaiveUTC is true (default), reinterpret it as if its local wall clock were UTC.
 * - Locale is taken from langOverride; if omitted, the browser decides (undefined).
 * - Time zone is taken from the browser; falls back to 'UTC' if unavailable.
 *
 * @param input         Date or ISO-like string (with or without timezone)
 * @param langOverride  Optional BCP-47 locale (e.g., 'es-ES'); if undefined, browser locale is used
 * @param opts          { assumeNaiveUTC?: boolean } default true; see behavior above
 */
export function formatDateFromUtcToLocale(input, langOverride, opts) {
    if (!input)
        return 'Weekly';
    let d;
    // Normalize strings: respect explicit timezone; otherwise treat as UTC by appending 'Z'
    if (typeof input === 'string') {
        d = /[zZ]$|[+-]\d{2}:\d{2}$/.test(input) ? new Date(input) : new Date(input + 'Z');
    }
    else {
        // Reinterpret Date as UTC wall clock if requested (default true)
        const assumeNaiveUTC = opts?.assumeNaiveUTC ?? true;
        d = assumeNaiveUTC
            ? new Date(Date.UTC(input.getFullYear(), input.getMonth(), input.getDate(), input.getHours(), input.getMinutes(), input.getSeconds(), input.getMilliseconds()))
            : input;
    }
    // Locale: override if provided; otherwise let the browser decide
    const locale = langOverride;
    // Time zone: always prefer the browser's
    const timeZone = typeof Intl !== 'undefined' && typeof Intl.DateTimeFormat === 'function'
        ? (Intl.DateTimeFormat().resolvedOptions().timeZone ?? 'UTC')
        : 'UTC';
    return new Intl.DateTimeFormat(locale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        timeZone
    }).format(d);
}
/** True for absolute http(s) URLs (e.g. Telegram, external campaigns). Not for in-app paths. */
export function isPromoExternalAbsoluteUrl(url) {
    return /^https?:\/\//i.test(url.trim());
}
export function openPromoExternalInNewTab(url) {
    if (typeof document === 'undefined')
        return;
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.click();
}
const REWARD_PROMO_ID_TO_REWARD_TYPE = {
    'daily-bonus': 'CASHBACK_DAILY',
    'weekly-bonus': 'CASHBACK_WEEKLY',
    'monthly-bonus': 'CASHBACK_MONTHLY',
    rakeback: 'RAKEBACK',
    'level-up': 'LEVEL_UP'
};
export function isRewardPromo(promo) {
    return promo.promoType === 'reward';
}
export function getRewardTypeForPromo(promo) {
    return promo.rewardType ?? REWARD_PROMO_ID_TO_REWARD_TYPE[promo.id];
}
export function isRewardPromoClaimReady(promo, vipState) {
    const rewardType = getRewardTypeForPromo(promo);
    if (!rewardType)
        return false;
    return (vipState?.rewards?.some((reward) => reward.rewardType === rewardType && reward.claimReady === true) ?? false);
}
